$shm_dashboard_admin_users $mol_book2
	selected_user_id? \
	add_opened? false
	filter? \
	placeholders /
	pages <= user_pages /
	Users_page $mol_page
		title \Пользователи
		head /
			<= List_head $shm_list_head
				title \Пользователи
				filter? <=> filter? \
				add? <=> user_add? null
				Close null
				Settings null
		body /
			<= Rows $mol_list
				rows <= body_rows /
	User_add $shm_dashboard_admin_user_add
		created? <=> user_created? \
	Dashboards $shm_dashboard_admin_user_dashboards
		user_id <= selected_user_id? \
		User_label null
	Table_head $mol_view
		sub /
			<= Table_head_email $mol_view
				sub / \Email
			<= Table_head_name $mol_view
				sub / \Имя
			<= Table_head_created $mol_view
				sub / \Создан
			<= Table_head_id $mol_view
				sub / \ID
	Row* $shm_dashboard_admin_users_row
		current <= user_current* false
		click? <=> user_pick*? null
		sub /
			<= Email* $mol_view
				sub / <= user_email* \
			<= Name* $mol_view
				sub / <= user_name* \
			<= Created* $mol_view
				sub / <= user_created_at* \
			<= Id* $mol_view
				sub / <= user_id* \
	Empty $mol_view
		sub / <= empty_message \

$shm_dashboard_admin_users_row $mol_button_minor
	current false
	attr *
		^
		shm_dashboard_admin_users_row_current <= current
